<template>
   <v-list-tile class="sidebar-profile">
		<v-avatar color="teal">
         <span class="white--text headline">{{user.username.substring(0,2).toUpperCase()}}</span>
      </v-avatar>
		<v-list-tile-content class="ml-3">
			<v-list-tile-title><span>{{ user.username }}</span></v-list-tile-title>
		</v-list-tile-content>
		<v-menu 
			bottom
			offset-y
			left
			content-class="userblock-dropdown" 
			nudge-top="-10"
			nudge-right="0"
			transition="slide-y-transition"
		>
			<v-btn dark icon slot="activator" class="ma-0">
					<v-icon>more_vert</v-icon>
			</v-btn>
			<div class="dropdown-content">
				<div class="dropdown-top white--text primary">
					<span class="white--text fs-14 fw-bold d-block">{{user.username}}</span>
					<span class="d-block fs-12 fw-light">{{ user.email }}</span>
				</div>
				<v-list class="dropdown-list">
					<v-list-tile @click="$store.dispatch('togggleUserSettingsDialogVisible')">
                  <i class="ti-user mr-3 primary--text"></i>
                  <span>{{$t('message.userProfile')}}</span>
					</v-list-tile>
					<v-list-tile @click="logoutUser">
						<i class="ti-power-off mr-3 error--text"></i>
						<span>{{$t('message.logOut')}}</span>
					</v-list-tile>
					<!-- <template v-for="userLink in userLinks" v-if="userLink.id !== 2">
						<v-list-tile :to="getMenuLink(userLink.path)" :key="userLink.id">
							<i :class="userLink.icon"></i>
							<span>{{$t(userLink.title)}}</span>
						</v-list-tile>
					</template>
					<template v-else>
						<v-list-tile @click="logoutUser" :key="userLink.id">
								<i :class="userLink.icon"></i>
								<span>{{$t(userLink.title)}}</span>
						</v-list-tile>
					</template> -->
				</v-list>
			</div>
		</v-menu>
   </v-list-tile>
</template>

<script>
import { getCurrentAppLayout } from 'Helpers/helpers'
import { mapGetters } from 'vuex'

export default {
	data() {
		return {
			userLinks: [
               {
                  id: 1,
                  title: 'message.userProfile',
                  icon: 'ti-user mr-3 primary--text',
                  path: '/users/user-profile'
               },
               {
                  id: 2,
                  title: 'message.logOut',
                  icon: 'ti-power-off mr-3 error--text',
                  path: '/session/login'
               }
            ]
		}
	},
	computed: {
         ...mapGetters([
            'user'
         ])
	},
	methods: {
		logoutUser() {
            this.$auth.logout()
         },
		getMenuLink(path) {
			return '/' + getCurrentAppLayout(this.$router) +  path;
		}
  	}
}
</script>
